module.exports = __webpack_public_path__ + "img/1.851e6867.png";